<template>
  <v-container>
    <portal to="pageTitle">
      <span>Список всех клубов</span>
    </portal>

    <v-card class="mx-auto" max-width="1200">
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">Название</th>
            <th class="text-left">Порядок</th>
            <th class="text-left">Описание</th>
            <th class="text-left">Картинка</th>
          </tr>
          </thead>

          <tbody v-if="hasItems">
          <tr v-for="item in computedItems" :key="item.id">
            <td>
              <router-link :to="{ name: 'clubs__id',  params: { id: item.id } }"> {{ item.id }}
              </router-link>
            </td>
            <td v-html="getAllLocalValue(item.name)" />
            <td v-html="item.sort" />
            <td v-html="getAllLocalValue(item.description)" />
            <td>
              <img width="50px" :src="item.image"/>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-container>
</template>

<script>
import ClubsListGQL from '../../graphql/private/Club/List.gql'
import Mixin from './components/Mixin'
import notify from '../../mixins/notify'

export default {
  mixins: [Mixin, notify],
  computed: {
    computedItems() {
      return this.clubList ? this.clubList : []
    },
    hasItems() {
      return this.computedItems.length > 0
    },
  },
  apollo: {
    clubList: {
      query: ClubsListGQL,
    },
  },
}
</script>
